import type { UsState } from "@/lib/us-states";

export type StateSource = "detected" | "selected" | "unknown";
export const EMAIL_CAPTURE_SURFACE = "email_popup_v2";
export const EMAIL_CAPTURE_DELAY_MS = 10_000;
export const EMAIL_CAPTURE_PHONE_HOME_DELAY_MS = 3_000;
export const EMAIL_CAPTURE_DISMISSED = "upsider_email_popup_dismissed";
export const EMAIL_CAPTURED = "upsider_email_captured";
export const EMAIL_CAPTURE_SESSION = "upsider_email_popup_shown";
export const EMAIL_CAPTURED_EVENT = "upsider:email-captured";
export const PHONE_POPUP_FLAG = "phone_popup_below_quiz_v1";
export const PHONE_POPUP_EXPOSURE_EVENT = "phone_popup_experiment_entered";

export function emailCaptureCta(state: UsState | null): string {
  return state ? `Send me the best bets in ${state}` : "Send me the best bets";
}

export function isEmailCaptureRoute(pathname: string | null): boolean {
  if (!pathname) return false;
  return pathname === "/" || pathname === "/learning-center/ads/charlie-pick6" || ["/tools", "/calculators", "/videos"].some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );
}
